Vendd.Scripts.load(function () {
    var $wrapper = $('.x-country-selector');

    if ($wrapper.length < 1)
        return;

    var wrapper = $wrapper.get(0);
    var $modal = $('.country-selector-wrapper', $wrapper);
    var countrySelectorSkipAutoOpenForCountries = $modal.attr('data-skip-auto-open-for-countries');
    var userCountryCode = $modal.attr('data-selected-country-code');
    var model, selectedCountry, countryRedirectUrl = "";

    //remove countries json from html
    $('.wrapper-to-delete', $wrapper).remove();

    $(".js-open-country-selector", $wrapper).fancybox({
        modal: true,
        touch: false
    });

    $(".js-close-country-selector", $modal).on('click', function () {
        if (countryRedirectUrl.length > 0 && userCountryCode !== selectedCountry.Code) {
            Cookies.set("ForceClearCartLocalStorage", 1, { samesite: 'Lax' });
            window.location.href = countryRedirectUrl;
        } else {
            $.fancybox.close();
        }
    });

    $('.js-change-country', $modal).on('click', function () {
        displayDropdownCountries(true);
    });

    $('.js-close-search', $modal).on('click', function () {
        displayDropdownCountries(false);
    });

    // init list search 
    var listSearch = new List('searchCountry', { valueNames: ['country'] });
    listSearch.on('updated', function (list) {
        if (list.matchingItems.length > 0) {
            $('.js-countries-list', $modal).show();
            $('.no-result', $modal).hide();
        } else {
            $('.no-result', $modal).show();
            $('.js-countries-list', $modal).hide();
        }
    });

    $(".js-country-option", $modal).click(function (e) {
        e.preventDefault();

        //generate redirect url
        countryRedirectUrl = $(this).data('country-url');

        var urlObject = new URL(countryRedirectUrl);
        urlObject.searchParams.delete("selectCountry");
        countryRedirectUrl = urlObject.toString();

        //apply country info
        var countryCode = $(this).data('country-code');
        selectedCountry = countriesJSON.filter(function (x) { return x.Code === countryCode; })[0];

        replaceSelectedCountryData(selectedCountry);

        displayDropdownCountries(false);
    });

    if (document.URL.indexOf('?selectCountry=y') > 1) {
        $(".js-open-country-selector", $wrapper).click();
    }

    if (localStorage.getItem('countrySelectorPopupOpened') !== 'true') {
        localStorage.setItem('countrySelectorPopupOpened', true);

        if ($modal.attr('data-open-on-first-load') === 'True') {
            if ($modal.attr('data-show-user-geo-location-country') === 'True') {
                Vendd.MessageBus.subscribe(Vendd.User.Messages.GetCountrySelectorSuccess,
                    wrapper,
                    function(envelope) {
                        model = envelope.message.data.model;

                        if (model) {
                            replaceSelectedCountryData(model.Selected);
                        }

                        openCountrySelectorPopupIfNotDefaultCountry(model);
                    });

                Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetCountrySelector());
            } else {
                openCountrySelectorPopupIfNotDefaultCountry();
            }
        }
    }

    function replaceSelectedCountryData(selectedCountry) {
        $('.selected-country svg', $modal).html('<use xlink:href="/Themes/templateThemeTwo/images/flags/flags.svg#' + selectedCountry.Code.toLowerCase() + '"></use>');
        $('.selected-country .name', $modal).text(selectedCountry.Name);
        $('.shipping-availability-text', $modal).html(selectedCountry.ShippingAvailabilityTitle);
        $('.shipping-country-geozone-terms', $modal).html(selectedCountry.TermsTitle);

        if (selectedCountry.ShippingAvailable) {
            $('.js-close-country-selector', $modal).removeClass('hidden');
        } else {
            $('.js-close-country-selector', $modal).addClass('hidden');
        }
    }

    function openCountrySelectorPopupIfNotDefaultCountry(model) {
        userCountryCode = model ? model.Selected.Code : userCountryCode;

        if (!countrySelectorSkipAutoOpenForCountries.includes(userCountryCode)) {
            $(".js-open-country-selector", $wrapper).click();
        }
    }

    function displayDropdownCountries(display) {
        if (display) {
            $('.dropdown-container', $modal).removeClass('hidden');
            $('.info-container', $modal).addClass('hidden');
        } else {
            $('.dropdown-container', $modal).addClass('hidden');
            $('.info-container', $modal).removeClass('hidden');
        }
    }
});